<template>
  <div class="sgs-icon">
    <svg :class="svgClass" aria-hidden="true" @click="svgClick">
      <use :href="iconName" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
  },
  methods: {
    svgClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.svg-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  overflow: hidden;
}

.sgs-icon {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/svgIcon/index.vue